/**
 * Constants for Cold Room U-Values Simulation
 * Defines simulation steps and physical constants
 */

// Simulation steps
export const FIRST_STEP = 'FIRST_STEP';
export const SECOND_STEP = 'SECOND_STEP';
export const THIRD_STEP = 'THIRD_STEP';

// Physical constants (ISO 6946 standards)
export const ALPHA_SI = 7.7; // Internal surface convective heat transfer coefficient [W/m²K]
export const ALPHA_SO = 25; // External surface convective heat transfer coefficient [W/m²K]

// Wall properties
export const LAMBDA_WALL = 0.462; // Thermal conductivity of wall [W/mK]
export const D_WALL = 220; // Thickness of wall [mm]

// Insulation properties
export const LAMBDA_INSULATION = 0.035; // Thermal conductivity of insulation [W/mK]
export const MIN_INSULATION = 0; // Minimum insulation thickness [mm]
export const MAX_INSULATION = 250; // Maximum insulation thickness [mm]
export const DEFAULT_INSULATION = 50; // Default insulation thickness [mm]

// Temperature settings
export const DEFAULT_ROOM_TEMP = 20; // Default room temperature [°C]
export const OUTDOOR_TEMP = 5; // Outdoor temperature [°C]
export const MAX_TEMP_DROP = 20; // Maximum temperature drop in animation [°C]

// Animation settings
export const FIRST_ROOM_INTERVAL = 1000; // Interval for first room level update [ms]
export const SECOND_ROOM_INTERVAL = 200; // Interval for second room level update [ms]
export const MAX_COLOR_LEVEL = 255; // Maximum color level for animations

// Building U-values for comparison
export const MODERN_BUILDING_U = 0.5; // Modern building U-value [W/m²K]
export const OLD_BUILDING_U = 2.5; // Old building U-value [W/m²K]
